import color from "../../../../../../constants/color";

const styles = {
  input: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      height: '41px',
      fontSize: '14px',
      '& input': {
        padding: '8.5px 14px',
      }
    }
  },
  inputLabel: {
    fontSize: '12px',
    fontWeight: '500',
    color: color.text,
    marginBottom: '8px'
  },
  container: {
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    margin: '20px'
  },
  container2: {
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    margin: '0px 20px'
  },
  container3: {
    padding: '20px 20px 4px 20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    margin: '0px 20px 0px 0px'
  },
  container4: {
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    margin: '0px 20px 0px 20px'
  },
  title: {
    fontWeight: 600,
    fontSize: '18px',
    color: '#202020',
    marginBottom: '20px',
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      height: '41px',
      borderRadius: '8px',
      '& fieldset': {
        border: '1px solid #D9D9D9',
      },
      '&:hover fieldset': {
        borderColor: '#D9D9D9',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#28AA4A',
      },
    },
    '& .MuiInputBase-input': {
      padding: '10px 15px',
      fontSize: '14px',
    },
  },
  multilineTextField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px !important',
      '& fieldset': {
        // border: '1px solid #D9D9D9',
      },
      '&:hover fieldset': {
        borderColor: '#D9D9D9',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#28AA4A',
      },
    },
    '& .MuiInputBase-input': {
      // padding: '10px 15px',
      fontSize: '14px',
    },
  },
  datePicker: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      height: '41px',
      width: '100%',
      borderRadius: '8px !important',
      '& fieldset': {
        border: '1px solid #D9D9D9',
      },
      '&:hover fieldset': {
        borderColor: '#D9D9D9',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#28AA4A',
      },
    },
    '& .MuiInputBase-input': {
      padding: '10px 15px',
      fontSize: '14px',
    },
  },
  datePickerOuter: {
    width: '100%',
    '& .MuiFormControl-root': {
      width: '100%',
      borderRadius: '8px !important',
    },
  },
  formSection: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    marginBottom: '24px',
  },
  field: {
    width: '100%',
    '& .MuiTypography-root': {
      fontSize: '14px',
      color: '#202020',
      fontWeight: 500,
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#fff',
      '& fieldset': {
        borderColor: '#E0E0E0',
      },
      '&:hover fieldset': {
        borderColor: '#28AA4A',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#28AA4A',
      },
    },
    '& .MuiInputBase-input': {
      fontSize: '14px',
      color: '#202020',
      '&::placeholder': {
        color: '#878787',
        opacity: 1,
      },
    },
  },
  itemsTitle: {
    margin: '0px 0px 0px 20px',
    fontSize: '14px',
    fontWeight: 500,
    color: '#202020',
    display: 'flex',
    alignItems: 'center',
    '&::before': {
      content: '""',
      width: '16px',
      height: '2px',
      backgroundColor: '#28AA4A',
      marginRight: '8px',
      borderRadius: '2px'
    }
  },
  itemsSection: {
    backgroundColor: '#fff',
    borderRadius: '8px',
  },
  itemRow: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    marginBottom: '12px',
    justifyContent: 'space-around'
  },
  itemField: {
    '& .MuiOutlinedInput-root': {
      height: '41px',
      borderRadius: '8px',
      '& fieldset': {
        border: '1px solid #D9D9D9',
      },
      '&:hover fieldset': {
        borderColor: '#D9D9D9',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#28AA4A',
      },
    },
    '& .MuiInputBase-input': {
      padding: '10px 15px',
      fontSize: '14px',
    },
  },
  descriptionField: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: '#fff',
      height: '41px',
      minWidth: '254px',
      '& fieldset': {
        border: '1px solid #D9D9D9',
      },
    },
  },
  quality: {
    width: '182px',
    height: '41px',
    paddingLeft: '2px !important',
    paddingRight: '0px !important'
  },
  quantityField: {
    width: '120px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px 0 0 8px',
      backgroundColor: '#fff',
      height: '41px',
      '& fieldset': {
        border: '1px solid #D9D9D9',
      },
    },
    '& input': {
      textAlign: 'left',
      padding: '10px 15px',
    },
  },
  quantityAddon: {
    width: '41px',
    height: '41px',
    backgroundColor: '#F5F5F5',
    border: '1px solid #D9D9D9',
    borderLeft: 'none',
    borderRadius: '0 8px 8px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#202020',
  },
  rateField: {
    width: '170px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: '#fff',
      height: '41px',
      '& fieldset': {
        border: '1px solid #D9D9D9',
      },
    },
    '& input': {
      textAlign: 'left',
      padding: '10px 15px',
    },
  },
  discountField: {
    width: '120px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: '#fff',
      height: '41px',
      '& fieldset': {
        border: '1px solid #D9D9D9',
      },
    },
    '& input': {
      textAlign: 'left',
      padding: '10px 15px',
    },
  },
  amountField: {
    width: '120px',
    textAlign: 'left',
    color: '#202020',
    fontSize: '14px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: '#fff',
      height: '41px',
      '& fieldset': {
        border: '1px solid #D9D9D9',
      },
    },
    '& input': {
      textAlign: 'left',
      padding: '10px 6px',
    },
  },
  addButton: {
    minWidth: '41px',
    width: '41px',
    height: '41px',
    borderRadius: '8px',
    backgroundColor: '#E8F7EE',
    color: '#28AA4A',
    padding: 0,
    '&:hover': {
      backgroundColor: '#d5f0e0',
    },
  },
  deleteButton: {
    minWidth: '41px',
    width: '41px',
    height: '41px',
    borderRadius: '8px',
    backgroundColor: '#FFE9E9',
    color: '#FF4842',
    padding: 0,
    '&:hover': {
      backgroundColor: '#ffd7d7',
    },
  },
  addItemButton: {
    color: '#28AA4A',
    '&:hover': {
      backgroundColor: 'rgba(40, 170, 74, 0.08)',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '20px',
    },
    textTransform: 'none',
    fontSize: '14px',
  },
  summarySection: {
    display: 'flex',
    gap: '24px',
    backgroundColor: '#fff',
    borderRadius: '8px',
  },
  customerNotes: {
    flex: 2,
    '& .MuiTypography-root': {
      fontSize: '14px',
      fontWeight: 500,
      color: '#202020',
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#fff',
      borderRadius: '8px',
      // border: '1px solid #D9D9D9',
    },
  },
  calculation: {
    backgroundColor: '#fff',
    borderRadius: '12px',
  },
  calculationRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .MuiTypography-root': {
      fontSize: '14px',
      color: '#202020',
      fontWeight: 500,
    },
  },
  termsSection: {
    '& .MuiTypography-root': {
      fontSize: '14px',
      color: '#202020',
      marginBottom: '8px',
      fontWeight: 500,
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#fff',
    },
  },
  attachmentSection: {
    '& .MuiTypography-root': {
      fontSize: '14px',
      color: '#202020',
      fontWeight: 500,
    },
  },
  fileBox: {
    '& .MuiTypography-root': {
      fontSize: '14px',
      color: '#878787',
      fontWeight: 500,
      marginBottom: '8px',
    }
  },
  fileDropArea: {
    backgroundColor: '#F9F9F9',
    border: '2px dashed #D9D9D9',
    borderRadius: '8px',
    padding: '24px',
    textAlign: 'center',
    transition: 'all 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      borderColor: '#28AA4A',
      backgroundColor: '#F5F5F5',
    },
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    '& .MuiButton-root': {
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 500,
    },
  },
  saveButton: {
    height: '37px',
    borderRadius: '42px',
    paddingTop: '8px',
    paddingRight: '30px',
    paddingBottom: '8px',
    paddingLeft: '30px',
    backgroundColor: '#28AA4A',
    opacity: 1,
    textTransform: 'none', // keeps the button text as-is
    '&:hover': {
      backgroundColor: '#229A43', // a slightly darker green on hover
    },
  },
  draftButton: {
    height: '37px',
    borderRadius: '42px',
    paddingTop: '8px',
    paddingRight: '30px',
    paddingBottom: '8px',
    paddingLeft: '30px',
    gap: '10px',              // gap applies to flex container children, not needed here usually
    backgroundColor: '#00ABF4',
    opacity: 1,
    textTransform: 'none',    // optional: keeps text as is (no uppercase)
    '&:hover': {
      backgroundColor: '#0096D6', // a slightly darker shade on hover (optional)
    },
  },
  cancelButton: {
    width: '111px',
    height: '37px',
    borderRadius: '42px',
    paddingTop: '8px',
    paddingRight: '30px',
    paddingBottom: '8px',
    paddingLeft: '30px',
    borderColor: '#878787',
    color: 'white !important',
    opacity: 1,
    textTransform: 'none',
    backgroundColor: '#878787',
    '&:hover': {
      borderColor: '#a0a0a0',
      backgroundColor: 'rgba(135, 135, 135, 0.1)',
    },
  },
  taxToggleGroup: {
    display: 'flex',
    flexWrap: 'nowrap',
    marginLeft: '-11px',
    justifyContent: 'space-between',
    '& .MuiToggleButtonGroup-root': {
      display: 'flex',
    },
    '& .MuiToggleButton-root': {
      border: 'none',
      padding: '8px 0px',
      borderRadius: '8px',
      '&.Mui-selected': {
        backgroundColor: 'transparent',
      },
    },
  },
  radioButton: {
    '& .MuiRadio-root': {
      padding: 0,
      marginRight: '8px',
      '&.Mui-checked': {
        color: '#28AA4A',
      },
    },
  },
  taxSelect: {
    marginBottom: '12px',
    '& .MuiOutlinedInput-root': {
      height: '41px',
      width: "100px",
      borderRadius: '8px',
      backgroundColor: '#fff',
      '& fieldset': {
        border: '1px solid #E0E0E0',
      },
    },
  },
  adjustmentInput: {
    '& .MuiOutlinedInput-root': {
      height: '41px',
      borderRadius: '8px',
      backgroundColor: '#fff',
      '& fieldset': {
        border: '1px solid #E0E0E0',
      },
    },
  },
  amountText: {
    textAlign: 'right',
    color: '#202020',
    fontSize: '14px',
    fontWeight: 500,
  },
  negativeAmount: {
    color: '#FF4842',
  },
  totalRow: {
    // paddingTop: '16px',
    marginTop: '10px',
    marginBottom: '0 !important',
  },
  customInput: {
    '& .MuiOutlinedInput-root': {
      paddingRight: '0px !important',
      borderRadius: '8px !important',
    }
  },
  inputBgBox: {
    borderRadius: '0px 8px 8px 0px',
    paddingRight: '4px',
    color: "#878787",
  },
  leaveSection: {
    px: 2
  },
  amount: {

    borderRadius: "8px",
    // my: 1,
    height: "2.8em",
    fontSize: "14px",
    fontWeight: "400",
    color: color.text,
    border: "1px solid #DEDEDE",
    paddingTop: 1,
    textAlign: "left",
    paddingLeft: 1.5
  },
  addIcon: {
    p: 1,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary
  },
  deleteIcon: {
    p: 1,
    pb: 0,
    backgroundColor: "#FBD6D6",
    borderRadius: "5px",
    color: color.red

  },

  inputContainer: {
    // width:{xs:"18em",md:"25em",},
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  inputContainerBox: {
    // width:{xs:"18em",md:"25em",},
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1,
  },

  modalInput: {
    display: "flex",    // backgroundColor:color.lightGray,
    // width:{ xs: "25em", md: "35em" },
    justifyContent: "center",// Center align on smaller screens
    my: "10px",
    height: "2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "5.5px 14px",
    },
    borderRadius: "8px",
    "& .MuiOutlinedInput-root": {
      padding: "1.1px",
      borderRadius: "8px",
      "& fieldset": {
        borderRadius: "8px",
      },
    },
    width: "100%"
  },


  uploadSection: {
    px: 2,
    width: { xs: "100%", md: "55%" },

    "& .css-2y07vr": {
      py: "7px"

    }
  },
  leaveInputGrid: {
    display: { xs: "block", md: "flex" },
    alignItems: "center",
    justifyContent: "space-between"

  },
  leaveSheetGrid: {
    display: { xs: "block", md: "flex" },
    ml: { xs: 0, md: 2 },
    mt: { xs: 0, md: 2 },
    height: "fit-content"
  },
  leaveSheet: {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "5px",
    px: 1,
    mr: 1,
    mb: { xs: 1, md: 0 },
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    " & .css-0": {
      display: "flex",

    },
  },
  closeIcon: {
    fontSize: "1rem",
    ml: 2,
  },

  inputBox: {
    width: { xs: "100%", md: "49%", lg: "32%" }
  },
  inputBox1: {
    width: { xs: "100%", md: "65.5%" }
  },
  inputText: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1,
  },
  uploadText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
    mt: 2,
    mb: 1,

  },
  gridbox: {
    backgroundColor: "#ffff",
    m: { xs: 1, sm: 2 },
    py: 2,
    px: { xs: 1, sm: 2 },
    borderRadius: "20px",
    height: "fit-content",
    overflow: "hidden",
    width: { xs: "calc(100% - 8px)", sm: "auto" }
  },
  gridboxs: {
    backgroundColor: "#ffff",
    mt: 2,
    mb: 2,
    py: 2,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },

  itemSection: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    mx: 2,
    alignItems: { xs: "flex-start", sm: "center" },
    width: "100%",
    gap: { xs: 2, sm: 0 }
  },
  gridText: {
    mx: 2,
    fontSize: "14px",
    fontWeight: "600"
  },
  bioBox: {
    px: 3,
    pt: 1,
  },
  content: {
    mt: 2,
    ml: 2,
    display: "flex",
    flexDirection: "row",
    // justifyContent:"space-Between"
  },
  switchSection: {
    display: "flex",
    alignItems: "center",
    mb: 1,
  },
  mainBoxes: {
    pr: { xs: 1, sm: 2 },
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: { xs: "stretch", sm: "flex-end" },
    gap: { xs: 1, sm: 2 }
  },
  jobButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    ml: 2,
    px: 4,
  },
  mainContainer: {
    justifyContent: "end",
    // pr:{xs:1, md:1}
  },
  cancelButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: color.primary,
    fontSize: "14px",
    fontWeight: "500",
    px: 4,
    mb: 1
  },
  switchKeyText: {
    width: { xs: "60%", md: "32%" }
  },
  switchContent: {
    fontSize: "12px",
    fontWeight: "500",
  },
  descText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color?.text,
  },
  descValueText: {
    fontSize: "14px",
    fontWeight: "500",
    color: color?.text,
  },
  descValueTexts: {
    fontSize: "14px",
    fontWeight: "600",
    color: color?.text,
  },

  infoSection: {
    px: 3,
  },
  bioIconText: {
    fontSize: "22px",
    fontWeight: "600",
  },
  textPrimary: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
  },
  line: {
    border: "1px solid #D9D9D9",
    my: 2,
    mx: 3
  },
  subHeading: {
    fontSize: "16px",
    fontWeight: "600"
  },
  contactSection: {
    mt: 4,
  },

  contenttSection: {
    mt: 2.5,
  },

  durationText: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "21px",

  },
  contactSubheading: {
    fontSize: "18px",
    fontWeight: "600",

  },
  infoBox: {
    display: "flex",
    mb: 1.5,
  },
  bioText: {
    fontSize: "14px",
    fontWeight: "600",
  },
  bioTextValue: {
    fontSize: "14px",
    fontWeight: "400",
    ml: 2,

  },
  bioTextValueSuccess: {
    fontSize: "14px",
    fontWeight: "400",
    ml: 2,
    color: color.primary,

  },
  detailText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.text
  },
  closeJob: {
    color: "#FF0000",
    fontSize: "14px",
  },
  removeSection: {
    display: "flex",
    alignItem: "center",
    justifyContent: "space-between",
    mt: 2,

  },
  liText: {
    fontSize: "14px",
    listStyle: "disc !important",
    display: "list-item",
  },
  createJob: {
    textAlign: "center",
  },
  lastGrid: {
    justifyContent: "space-between",
    mx: 2
  },
  dateInput: {
    width: "100%",
    my: 1,

    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    // mt: 1,
    marginBottom: '8px',
  },
  countryCode: {
    ".react-tel-input": {
      width: "100%",
      "& .form-control": {
        width: "100%",
        height: "40px",
        fontSize: "14px"
      },
      "& .selected-flag": {
        "& .flag": {
          mt: "-9px",
        },
      },
      "@media (max-width: 600px)": {
        "& .form-control": {
          fontSize: "13px",
          height: "36px"
        }
      }
    },
  },
  addressBox: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    gap: { xs: "16px", md: "3%" },
    px: { xs: 1.5, sm: 2 },
    width: "100%"
  },
  addressInput: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: { xs: "flex-start", sm: "space-between" },
    alignItems: { xs: "stretch", sm: "center" },
    gap: { xs: 2, sm: 0 },
    my: { xs: 2, sm: 3 },
    width: "100%"
  },
  addressTextField: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      width: "100%"
    },
    "& .MuiOutlinedInput-input": {
      fontSize: { xs: "13px", sm: "14px" },
      fontWeight: 400,
      padding: { xs: "10px 12px", sm: "14px" }
    },
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
      fontSize: "12px"
    },
    "@media (max-width: 600px)": {
      marginBottom: "8px"
    }
  },
  addressSection: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: { xs: 2, sm: 3 },
    padding: { xs: "16px 12px", sm: "20px 16px" },
    backgroundColor: "#fff",
    borderRadius: "8px",
    "& .MuiFormControl-root": {
      width: "100%"
    }
  }
};

export default styles; 